import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { REJECT_SESSION_TRANSFER, REJECT_SESSION_TRANSFER_SUCCESS, REJECT_SESSION_TRANSFER_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* RejectSessionTransfer({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { transferId } = payload.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/transfer-requests/${transferId}/deny`,
      method: 'POST',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: REJECT_SESSION_TRANSFER_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: REJECT_SESSION_TRANSFER_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: REJECT_SESSION_TRANSFER_ERROR, payload: error });
  }
}

export function* watchRejectSessionTransfer() {
  yield takeEvery(REJECT_SESSION_TRANSFER, RejectSessionTransfer);
}

function* RejectSessionTransferSaga() {
  yield all([fork(watchRejectSessionTransfer)]);
}

export default RejectSessionTransferSaga;
